import { render, staticRenderFns } from "./IconFilters.vue?vue&type=template&id=6db466a5&"
import script from "./IconFilters.vue?vue&type=script&lang=js&"
export * from "./IconFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6db466a5')) {
      api.createRecord('6db466a5', component.options)
    } else {
      api.reload('6db466a5', component.options)
    }
    module.hot.accept("./IconFilters.vue?vue&type=template&id=6db466a5&", function () {
      api.rerender('6db466a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconFilters.vue"
export default component.exports